module.exports = __webpack_public_path__ + "img/5d5ce4e.png";